var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.36652 19.7085C0.77152 20.0985 1.42652 20.0985 1.83052 19.7085L10.3935 11.4445C10.5852 11.2623 10.7378 11.0431 10.8421 10.8001C10.9464 10.5571 11.0002 10.2954 11.0002 10.031C11.0002 9.76658 10.9464 9.50491 10.8421 9.26191C10.7378 9.01892 10.5852 8.79967 10.3935 8.61751L1.76852 0.292509C1.57277 0.106456 1.31355 0.00188248 1.0435 2.51689e-05C0.773443 -0.00183215 0.512807 0.0991663 0.31452 0.282509C0.216291 0.373049 0.137696 0.482791 0.0836001 0.604938C0.0295044 0.727085 0.00106027 0.859038 2.90802e-05 0.992624C-0.00100211 1.12621 0.0254016 1.25859 0.0776052 1.38155C0.129809 1.50452 0.206701 1.61546 0.30352 1.70751L8.19752 9.32451C8.29344 9.4156 8.36982 9.52525 8.42201 9.64679C8.47421 9.76834 8.50112 9.89923 8.50112 10.0315C8.50112 10.1638 8.47421 10.2947 8.42201 10.4162C8.36982 10.5378 8.29344 10.6474 8.19752 10.7385L0.36652 18.2955C0.27063 18.3865 0.194268 18.4961 0.142085 18.6175C0.089903 18.739 0.0629923 18.8698 0.0629923 19.002C0.0629923 19.1342 0.089903 19.265 0.142085 19.3865C0.194268 19.5079 0.27063 19.6175 0.36652 19.7085Z",
    fill: "#663399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b7b30a8dceb1ab4173dbf07f6ddd33a2.svg";
export { ForwardRef as ReactComponent };